var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"swatch-list"},_vm._l((_vm.colorSwatches),function(color){return _c('li',{key:color.value,staticClass:"swatch-list__item"},[_c('button',{staticClass:"swatch-list__swatch",class:{
          'swatch-list__swatch--selected':
            color.value.toLowerCase() === _vm.selectedSwatch.toLowerCase(),
          'swatch-list__swatch--border': color.value === '#ffffff',
        },style:({ backgroundColor: color.value }),on:{"click":function($event){return _vm.selectColor(color.value)}}},[_c('span',{staticClass:"swatch-list__swatch-name"},[_vm._v(_vm._s(color.value))])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }